// Unique code to get top level Page Component and Page SCSS
import React from 'react';
// All boilerplate cut/paste stuff
import ReactDOM from 'react-dom/client';
import { JobContextProvider } from '../../../contexts/JobContext';
import { Provider as PageContext } from '../../../contexts/PageContext';
// The only thing different is the from part should match your component
import PAGE_COMPONENT from './TopCompaniesV2';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PageContext PAGE_PROPS={props.PAGE_PROPS}>
        <JobContextProvider
            userStatusOfCompletenes={props.userStatusOfCompleteness}
            session={props.PAGE_PROPS.session}
            currentUrl={props.PAGE_PROPS.headerProps.currentUrl}
            content={[]}
            attributionMode="none"
        >
            <PAGE_COMPONENT {...props} />
        </JobContextProvider>
    </PageContext>
);

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 
*  To render the component:
*
*  req.reactRender = {
*      componentPath: 'Ratings/TopCompaniesV2/TopCompaniesV2,
*      props: {},
*      metaTagData:{}
*  }
*
*  next();
*  return;
*

 */
